import AirbnbPropTypes from 'airbnb-prop-types';
import PropTypes from 'prop-types';

/**
 * Validate that each children is either null, false, undefined or one of the given element types.
 * @param types
 */
const childrenOfTypes = (...types) => PropTypes.oneOfType([
  AirbnbPropTypes.childrenOfType(...types),
  PropTypes.arrayOf(AirbnbPropTypes.childrenOfType(...types)),
]);

export default childrenOfTypes;
